import React from 'react';

export default function Alert() {
    return (
        <div className='alert'>Please fill in all the slots with a color <br></br>before checking.</div>
    )
}
